import React from "react";
import * as Styled from "./styles.module";
import { Modal } from "../../../components/UIKitComponents/Modal/Modal";
import { Icon } from "../../../components/UIKitComponents/Icon/Icon";
import { Agent } from "../../../models";
// import { Phone } from '../../../utils/Phone';
import { User } from "../../../communications/states/WorkspacesState";

export type PartialUser = Partial<User>;

interface IWorkspaceListProps {
  show: boolean;
  onHide(): void;
  onChangeWorkspace(workspace: PartialUser | null): void;
  savedWorkspaceData: PartialUser | null;
  workspaces: PartialUser[];
  agent: Agent;
}

interface IWorkspaceListState {
  temporarySelectedWorkspace: PartialUser | null;
  serachValue: string;
}

export class WorkspaceList extends React.Component<
  IWorkspaceListProps,
  IWorkspaceListState
> {
  state: IWorkspaceListState = {
    temporarySelectedWorkspace: null,
    serachValue: "",
  };

  restoreState() {
    this.setState({
      temporarySelectedWorkspace: null,
      serachValue: "",
    });
  }

  closeWorkspaceList() {
    this.restoreState();
    this.props.onHide();
  }

  moveSelectedItemToTop(): PartialUser[] {
    const savedWorkspaceData: any = this.props.savedWorkspaceData || {};
    const workspaceList = [...this.props.workspaces];
    const selectedItemIndex = workspaceList.findIndex(
      (it) => it.uid === savedWorkspaceData.uid
    );
    const listWithSelectedItem = workspaceList.splice(selectedItemIndex, 1);
    return listWithSelectedItem.concat(workspaceList);
  }

  renderWorkspacesList() {
    const savedWorkspaceData: any = this.props.savedWorkspaceData || {};
    const workspaceList = this.moveSelectedItemToTop();

    return workspaceList
      .filter(
        (it) =>
          it.phone &&
          it.phone.length > 0 &&
          it.source?.isDsr() &&
          (it.full_name || "")
            .toLowerCase()
            .includes(this.state.serachValue.toLowerCase())
      )
      .map((it) => {
        return (
          <Styled.PhoneItem
            key={it.uid}
            selected={this.state.temporarySelectedWorkspace?.uid === it.uid}
            onClick={() => this.setState({ temporarySelectedWorkspace: it })}
          >
            <Styled.PhoneItemTitle>
              {savedWorkspaceData.uid === it.uid ? (
                <Icon color="#2EC959" icon="check" />
              ) : null}
              {it.full_name}
            </Styled.PhoneItemTitle>
            <Styled.PhoneItemValue>{it.phone}</Styled.PhoneItemValue>
          </Styled.PhoneItem>
        );
      });
  }

  render() {
    const selectedWorkspace = this.state.temporarySelectedWorkspace;
    const savedWorkspaceData =
      this.props.savedWorkspaceData || ({} as PartialUser);
    const isActiveChangeBtn =
      selectedWorkspace && savedWorkspaceData.uid !== selectedWorkspace?.uid;

    return (
      <Modal
        width={650}
        title="Check personal SMS"
        show={this.props.show}
        onHide={() => this.closeWorkspaceList()}
        darkShadow
        closeBtn
      >
        <Styled.FilterInput
          placeholder="Filter by name"
          value={this.state.serachValue}
          onChange={(event: any) => {
            this.setState({ serachValue: event.target.value });
          }}
        />

        <Styled.PhoneList>{this.renderWorkspacesList()}</Styled.PhoneList>

        <Styled.ButtonsRow>
          <Styled.CancelBtn
            className="typo typo-text-14"
            onSubmit={() => {
              this.props.onChangeWorkspace(null);
              this.props.onHide();
            }}
            size="medium"
          >
            Reset
          </Styled.CancelBtn>

          <Styled.ChangeBtn
            className="typo typo-text-14"
            onSubmit={() => {
              this.props.onChangeWorkspace(selectedWorkspace);
              this.closeWorkspaceList();
            }}
            disabled={!isActiveChangeBtn}
            size="medium"
          >
            Change
          </Styled.ChangeBtn>
        </Styled.ButtonsRow>
      </Modal>
    );
  }
}
